package org.zq.astrock_ai.ui.research.gushi.data

import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.zq.astrock_ai.api.dto.PhoneNumbers
import org.zq.astrock_ai.storage.ResearchKvStorage

@Serializable
data class AuthSession(
    val phone: String,
    val token: String,
    val loggedAtMs: Long = 0L,
    val superAdmin: Boolean = false,
    val role: String = "user",
)

object AuthSessionStore {
    private const val KEY = "auth.session.v1"
    private const val LAST_PHONE_KEY = "auth.last_phone.v1"
    private val json = Json { ignoreUnknownKeys = true }

    fun load(): AuthSession? {
        val raw = ResearchKvStorage.get(KEY)?.trim().orEmpty()
        if (raw.isBlank()) return null
        val session = runCatching { json.decodeFromString<AuthSession>(raw) }.getOrNull() ?: return null
        val phone = PhoneNumbers.normalize(session.phone)
        return if (PhoneNumbers.isCnMobile(phone) && session.token.isNotBlank()) {
            session.copy(phone = phone)
        } else {
            null
        }
    }

    fun lastPhone(): String {
        load()?.phone?.let { if (PhoneNumbers.isCnMobile(it)) return it }
        val saved = PhoneNumbers.normalize(ResearchKvStorage.get(LAST_PHONE_KEY).orEmpty())
        return if (PhoneNumbers.isCnMobile(saved)) saved else ""
    }

    fun save(session: AuthSession) {
        val phone = PhoneNumbers.normalize(session.phone)
        ResearchKvStorage.put(KEY, json.encodeToString(session.copy(phone = phone)))
        if (PhoneNumbers.isCnMobile(phone)) {
            ResearchKvStorage.put(LAST_PHONE_KEY, phone)
        }
    }

    fun clear() {
        ResearchKvStorage.put(KEY, "")
    }
}
